<template>
  <div class="abilityDetails">

    <!-- 标题 -->
    <div class="title">情绪与健康分析</div>
    <div class="list">报告列表</div>
    <div class="content" v-if="reportListData.length > 0">
      <div class="report" v-for="(item, index) in reportListData" :key="index">
        <div class="item">
          <div class="name">{{ item.userName }}</div>
          <div class="sex">先生</div>
        </div>
        <div class="item">
          <div class="ID">ID:{{ item.dataValue }}</div>
          <div class="detection">检测日期:{{ item.reportTime }}</div>
        </div>
        <div class="result">《{{ item.checkReportName }}》</div>
        <div class="br"></div>
        <div class="ctv">点击查看详情</div>
        <img class="go" src="../../../assets/go.png" @click="changePages(item.ossReportPDF)" alt="">
      </div>
    </div>

    <div v-else class="null">
      暂时还没有数据
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GetCoreReportListData } from '../../../api'
export default {
  name: '',
  components: {
    // pdf,
  },
  data () {
    return {
      reportListData: []
    }
  },
  methods: {
    // 获取用户信息
    getCoreReportListData () {
      this.$toast.loading({
        message: '获取信息中'
      })
      GetCoreReportListData({ userid: this.userid }).then(res => {
        const { data } = res
        if (data) {
          this.reportListData = data
        } else {
          this.$toast.fail('信息获取失败')
        }
        this.$toast.clear()
      })
    },
    changePages (pdfUrl) {
      window.open(pdfUrl)
    }

  },
  created () {
  },
  mounted () {
    this.getCoreReportListData()
  },
  computed: {
    ...mapGetters([
      'userid'
    ])
  }
}
</script>

<style lang="scss" scoped>
.abilityDetails {
  height: 100%;
  background: #f2f2f2;
  background-size: 100%;
  color: #929292;
  font-size: 23px;
  overflow-y: scroll;

  .title {
    text-align: center;
    margin: -30px 0 30px 0px;
  }

  .list {
    position: relative;
    margin: 10px 40px;
    font-size: 18px
  }

  .list::before {
    content: "";
    width: 7px;
    height: 20px;
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 5px;
  }

  .list::before {
    background: #FF9580;
  }

  .content {
    margin-top: 10px;

    .report {
      width: 95%;
      margin: 10px;
      height: 200px;
      background-color: #ffffff;
      border-radius: 10px;

      .item {
        display: flex;
        font-size: 15px;

        .name {
          font-size: 25px;
          padding: 20px;
        }

        .sex {
          margin: 30px -10px;
        }

        .ID {
          margin: -20px 20px;
        }

        .detection {
          margin: -22px 0;
        }

      }

      .result {
        font-size: 28px;
        text-align: center;
        margin: 10px auto;
      }

      .br {
        border-bottom: 2px dotted;
      }

      .ctv {
        font-size: medium;
        margin: 10px 80px;
        text-align: right;
      }

      .go {
        width: 40px;
        height: 19px;
        margin: -29px 0px 0px 300px;
      }
    }
  }

  .null {

    width: 95%;
    margin: 10px;
    height: 200px;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    line-height: 200px;
  }

}
</style>
